import { useParams } from 'react-router-dom';
import ContentPageLayout from '../../components/common/ContentPageLayout';
import { usePolicy } from '../../hooks/usePolicy';
import { POLICY_LABELS } from '../../utils/contentMappers';

function PolicyPage() {
  const { type } = useParams();
  const { policy, loading, error } = usePolicy(type);
  const title = policy?.title || POLICY_LABELS[type] || 'Policy';

  return (
    <ContentPageLayout
      title={title}
      content={policy?.content}
      loading={loading}
      error={error}
    />
  );
}

export default PolicyPage;
